const DEFAULT_BOX_BG = `radial-gradient(70.71% 70.71% at 50% 50%, rgba(12, 148, 149, 0) 33.78%, rgba(12, 148, 149, 0.05) 100%),
      radial-gradient(98.51% 99.04% at 31.29% 28.66%, rgba(12, 148, 149, 0.1) 0%, rgba(255, 255, 255, 0) 80.51%),
      radial-gradient(1470.89% 239.61% at -43.09% -106.76%, rgba(12, 148, 149, 0.3) 0%, rgba(12, 148, 149, 0) 99.27%),
      rgba(12, 148, 149, 0.2)`;
const DEFAULT_BOX_BORDER = `#0c9495`;
const DEFAULT_BOX_SHADOW = `rgba(255, 255, 255, 0.35) 0px 0px 10.165px 5.57px inset, rgba(0, 0, 0, 0.25) 0px 2.228px 17.823px 0px inset`;
const DEFAULT_MEDIA_BG = `var(--color-white, #fff)`;
const DEFAULT_MEDIA_BOX_SHADOW = `inset 0px 0px 21.165px 5.57px rgba(255, 255, 255, 0.35)`;
const DEFAULT_MEDIA_GRADIENT_1 = `linear-gradient(13.2deg, #000000 44.11%, rgba(0, 0, 0, 0) 61.05%)`;
const DEFAULT_MEDIA_GRADIENT_2 = `linear-gradient(0deg, rgba(0, 0, 0, 0.8) 40.87%, rgba(0, 0, 0, 0) 100%)`;

export { DEFAULT_BOX_BG, DEFAULT_BOX_BORDER, DEFAULT_BOX_SHADOW, DEFAULT_MEDIA_BG, DEFAULT_MEDIA_BOX_SHADOW, DEFAULT_MEDIA_GRADIENT_1, DEFAULT_MEDIA_GRADIENT_2 };
//# sourceMappingURL=layers.js.map
